// AUTO-GENERATED from servers/common-servers-v2/helpers/FormHelper/to_text.js by servers/common-servers-v2/scripts/sync-form-helper.js.
// Do not edit: change the source and run `node scripts/sync-form-helper.js`.
/* eslint-disable */
import { format_stored_date } from "./date.js";

/*
 * to_text(value, field, { lang, digits }) -> plain readable text of one stored
 * value, used by search, Excel and the panel's key/value view (spec §5):
 * option -> title, array -> titles joined, date -> Jalali, file -> file name.
 * `lang`: "fa" (default, joins with "، ") or "en" (", "). `digits`: "latin" (default) or "fa".
 */

const is_plain_object = (value) => value !== null && typeof value === "object" && !Array.isArray(value);

const group_thousands = (number) => String(number).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

const to_text = (value, field = {}, options = {}) => {
    if (value === undefined || value === null) {
        return "";
    }
    const lang = options.lang === "en" ? "en" : "fa";
    const separator = lang === "en" ? ", " : "\u060C ";

    if (Array.isArray(value)) {
        return value.map((item) => to_text(item, field, options)).filter((text) => text !== "").join(separator);
    }
    if (field.type === "date" && typeof value === "string") {
        return format_stored_date(value, field.data?.mode, { digits: options.digits }) || value;
    }
    if (field.type === "price" && typeof value === "number") {
        return group_thousands(value);
    }
    if (typeof value === "string") {
        return value;
    }
    if (typeof value === "number") {
        return String(value);
    }
    if (typeof value === "boolean") {
        return lang === "en" ? (value ? "Yes" : "No") : (value ? "\u0628\u0644\u0647" : "\u062E\u06CC\u0631");
    }
    if (is_plain_object(value)) {
        if (typeof value.title === "string") {
            return value.title;
        }
        // file: stored { name } or input { file_name }
        if (typeof value.name === "string" && ("media_id" in value || "url" in value)) {
            return value.name;
        }
        if (typeof value.file_name === "string") {
            return value.file_name;
        }
        try {
            return JSON.stringify(value);
        } catch {
            return "";
        }
    }
    return "";
};

export {
    to_text,
};
